import http from 'plugins/axios';

export default {
  getCurrencyList() {
    return http.post({
      url: '/admin/mytoken/search'
    });
  },
  getCurrencyDetail(id) {
    return http.get({
      url: `/admin/mytoken/detail/${id}`
    });
  },
  addCurrency(data) {
    //symbol货币名称，name货币全称
    return http.post({
      url: '/admin/mytoken/addToken',
      data,
      dataType: 'form'
    });
  },
  bindThirdPart(id) {
    return http.get({
      url: `/admin/mytoken/createTokenToMytoken/${id}`
    });
  },
  getCoinList() {
    return http.get({
      url: '/admin/mytoken/coinList'
    });
  }
};
